import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PriceBlock() {
  return <section id="pricing-section" className="bg-charcoal py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-116">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-orange/20 blur-[100px] rounded-full pointer-events-none" data-id="element-117"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-119">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-white mb-6 leading-tight" data-id="element-120">
            Recupera tu capacidad de trabajar y vivir sin agonía
          </h2>

          <p className="font-body text-xl text-white/80 mb-12 max-w-2xl mx-auto" data-id="element-121">
            Por menos de lo que cuesta un copago médico en USA. Consigue el{' '}
            <strong className="text-white" data-id="element-122">Protocolo SOS Nervio Ciático</strong>{' '}
            completo hoy mismo.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm max-w-xl mx-auto" data-id="element-123">
            <div className="mb-2 text-orange font-bold tracking-widest uppercase text-sm" data-id="element-124">
              Precio Especial
            </div>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-125">
              <span className="text-3xl text-white/40 line-through font-heading" data-id="element-126">
                $97
              </span>
              <span className="text-6xl md:text-7xl font-heading font-black text-white" data-id="element-127">
                $6.39{' '}
                <span className="text-2xl text-white/60 font-body font-normal" data-id="element-128">
                  USD
                </span>
              </span>
            </div>

            <CTAButton className="mx-auto" href="https://tiendadelibrosdigital.com/cart/42558801674311:1" data-id="element-129" />

            <div className="mt-6 flex items-center justify-center space-x-4 text-white/50 text-sm font-body" data-id="element-130">
              <span data-id="element-131">✓ Pago 100% Seguro</span>
              <span data-id="element-132">•</span>
              <span data-id="element-133">✓ Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}